import type { $Fetch } from "ofetch";

const controller = "/Medware/Avaliacao";

export default class AvaliacaoApi {
  private api;
  private tokenAgendamento: string | null = null;

  constructor(api: $Fetch) {
    this.api = ((request: string, options: any = {}) => {
      return api(request, {
        ...options,
        headers: {
          ...this.authHeaders(),
          ...(options?.headers || {}),
        },
      });
    }) as $Fetch;
  }

  setTokenAgendamento(token: string | null | undefined) {
    const tokenValue = (token || "").trim();
    this.tokenAgendamento = tokenValue
      ? tokenValue.startsWith("Bearer ")
        ? tokenValue
        : `Bearer ${tokenValue}`
      : null;
  }

  private authHeaders() {
    return this.tokenAgendamento
      ? { Authorization: this.tokenAgendamento }
      : {};
  }

  salvar(avaliacao: any) {
    return this.api<ApplicationModule[]>(`${controller}/Salvar`, {
      method: "POST",
      body: avaliacao,
    });
  }

  listar(dataInicio: string, dataFim: string, tipoData: number) {
    return this.api<any[]>(`${controller}/Listar`, {
      method: "GET",
      params: { dataInicio, dataFim, tipoData },
    });
  }

  buscar(codAgendamento: number) {
    return this.api<any>(`${controller}/Buscar`, {
      method: "GET",
      params: { codAgendamento },
    });
  }

  conferir(codAgendamento: number) {
    return this.api<any>(`${controller}/Conferir`, {
      method: "POST",
      params: { codAgendamento },
    });
  }
}
